var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 28.400051 25.400049", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.16.979A1.7 1.7 0 0 1 1.7 0h25a1.7 1.7 0 0 1 1.333 2.755L18.9 14.291V23.7a1.7 1.7 0 1 1-3.4 0v-10c0-.383.13-.755.367-1.055L23.186 3.4H5.33l7.676 9.212A1.7 1.7 0 0 1 13.4 13.7v6a1.7 1.7 0 1 1-3.4 0v-5.385L.394 2.788A1.7 1.7 0 0 1 .161.978z", fill: "#000" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.2 15.2h-5.5v-3h5.5z", fill: "#000" })
  );
});